import React, { memo } from "react";
import { styled } from "goober";

import StaticTFT from "@/game-tft/static.mjs";
import Check from "@/inline-assets/check.svg";
import HextechMatchGoldIcon from "@/inline-assets/hextech-match-gold.svg";

const ChampionImage = ({
  champKey,
  cost,
  size = 52,
  colorlessBorder,
  children = null,
  costPill,
  set,
  skinSetting = false,
  chosen,
  checked = false,
  lazyLoad = false,
  ...restProps
}) => {
  if (!champKey) return null;
  const color = StaticTFT.getRarityFromTier(cost);
  const champImg = StaticTFT.getChampionImage(
    champKey,
    skinSetting ? (set ?? "") : "",
  );
  return (
    <ChampImageFrameOuter {...restProps}>
      <ChampImageFrame style={{ width: `${size}px`, height: `${size}px` }}>
        <ChampImage
          data-champkey={champKey}
          data-unit={champKey}
          src={champImg}
          alt={`${champKey} - Teamfight Tactics`}
          style={{
            width: `${size}px`,
            height: `${size}px`,
            background: colorlessBorder && `var(--shade5)`,
          }}
          loading={lazyLoad ? "lazy" : "eager"}
        />
        {children}
      </ChampImageFrame>
      {checked && (
        <PurchasedCover>
          <Check />
        </PurchasedCover>
      )}
      {!!cost && (
        <TierRing
          className={!!chosen && "chosen"}
          style={{
            width: `${size + 2}px`,
            height: `${size + 2}px`,
            background: colorlessBorder ? `var(--shade5)` : cost && color,
          }}
        />
      )}
      {costPill && (
        <ChampCost style={{ background: color || "var(--shade9)" }}>
          <HextechMatchGoldIcon />
          {cost}
        </ChampCost>
      )}
    </ChampImageFrameOuter>
  );
};

const MemoChampionImage = memo(ChampionImage);
export default MemoChampionImage;

const ChampImageFrameOuter = styled("div")`
  position: relative;
`;
const PurchasedCover = styled("div")`
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 1;
  transform: translate(-50%, -50%);
  background: var(--shade8-50);
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    margin: 0 !important;
    height: initial !important;
    width: initial !important;
    color: var(--green);
    stroke: var(--shade8);
    stroke-width: 2px;
    paint-order: stroke fill;
  }
`;
const ChampImageFrame = styled("div")`
  box-sizing: border-box;
  position: relative;
  height: var(--sp-13);
  width: var(--sp-13);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: var(--br-sm);
  border: var(--sp-0_5) solid var(--shade9);
  background: var(--shade6);
  z-index: 1;
`;
const ChampImage = styled("img")`
  display: block;
  background: var(--shade7);
  margin: 0 !important;
  width: 100%;
  height: 100%;
  &:hover {
    filter: brightness(1.3);
  }
`;
const TierRing = styled("div")`
  position: absolute;
  top: calc(-1 * var(--sp-px));
  left: calc(-1 * var(--sp-px));
  width: var(--sp-13_5);
  height: var(--sp-13_5);
  border-radius: var(--sp-1);
  z-index: 0;

  &.chosen {
    background: linear-gradient(
      132.18deg,
      #fcfdff 0%,
      rgba(234, 242, 255, 0.865225) 20.13%,
      rgba(169, 185, 212, 0.53) 60.43%,
      rgba(187, 201, 224, 0.47) 95.54%
    );
    filter: drop-shadow(0 0 var(--sp-1) rgba(255, 255, 255, 0.4));
  }
`;
const ChampCost = styled("span")`
  box-sizing: border-box;
  position: absolute;
  top: calc(-1 * var(--sp-px));
  left: calc(-1 * var(--sp-px));
  z-index: 1;
  display: flex;
  height: var(--sp-4);
  width: var(--sp-6);
  align-items: center;
  justify-content: center;
  font-weight: 700;
  color: var(--shade0);
  font-size: var(--sp-3);
  line-height: 1.5;
  border-radius: var(--br) 0 5px 0;
  text-shadow: 0 var(--sp-px) 0 rgba(0, 0, 0, 0.6);
  svg {
    margin: calc(-1 * var(--sp-0_5)) var(--sp-0_5) 0 0;
    height: var(--sp-2);
    width: var(--sp-2);
    filter: drop-shadow(0 var(--sp-px) rgba(0, 0, 0, 0.3));
    color: var(--shade0);
  }
`;
